// extracted by mini-css-extract-plugin
export default {"infoList":"aTCQ6z0mOp+89cIebD+m3A=="};